import { render, staticRenderFns } from "./PreInvoice.vue?vue&type=template&id=5533cc6c&scoped=true&"
import script from "./PreInvoice.vue?vue&type=script&lang=ts&"
export * from "./PreInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./PreInvoice.vue?vue&type=style&index=0&id=5533cc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5533cc6c",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
